import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setIsPayment,
  setCardData,
} from '../../features/userSettings/userSettingsSlice';
import Button from '../../components/reusable/Button/Button';
import mastercard from '../../assets/mastercard.svg';
import visa from '../../assets/visa.svg';
import discover from '../../assets/discover.png';
import unionpay from '../../assets/unionpay.png';
import diners from '../../assets/diners.png';
import eftpos_au from '../../assets/eftpos_au.png';
import unknown from '../../assets/unknown.png';
import jcb from '../../assets/jcb.png';
import amex from '../../assets/amex.png';
import americanExpress from '../../assets/americanExpress.svg';
import maestro from '../../assets/maestro.svg';
import css from './UserSettings.module.css';
import apiv2 from '../../config/apiv2';
import { setMe } from '../../features/me/meSlice';

const Payment = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const cardData = useSelector(state => state.userSettings.cardData);

  useEffect(() => {
    setIsLoading(true);
    apiv2
      .COMPANIES_BILLING_GET()
      .then(res => dispatch(setCardData(res.data)))
      .finally(() => setIsLoading(false));
  }, []);

  const handlePayment = () => dispatch(setIsPayment(true));

  const firstChar = cardData?.stripe_card_brand?.charAt(0)?.toUpperCase();
  const restOfString = cardData?.stripe_card_brand?.slice(1);

  const formattedString =
    firstChar && restOfString ? firstChar + restOfString : '';

  return isLoading ? (
    <div className={css.containerForLoader}>
      <div className={css.loader}></div>
    </div>
  ) : (
    <div className={css.containerPaiment}>
      <h2 className={css.title}>Payment Information</h2>
      <div className={`${css.content} ${css.center}`}>
        <div className={css.payment}>
          <div>
            {!cardData?.stripe_payment_method_id && (
              <>
                <p className={css.paymentTitle}>No payment method added</p>
                <p className={css.infoText}>
                  Add a payment method before your free trial ends
                </p>
                <div className={css.imgsContainer}>
                  <img alt="mastercard" src={mastercard} />
                  <img alt="visa" src={visa} />
                  <img alt="americanExpress" src={americanExpress} />
                  <img alt="maestro" src={maestro} />
                </div>
              </>
            )}

            {cardData?.stripe_payment_method_id && (
              <div style={{ display: 'flex' }}>
                {cardData?.stripe_card_brand === 'amex' && (
                  <img alt="amex" className={css.image} src={amex} />
                )}
                {cardData?.stripe_card_brand === 'diners' && (
                  <img alt="diners" className={css.image} src={diners} />
                )}
                {cardData?.stripe_card_brand === 'discover' && (
                  <img alt="discover" className={css.image} src={discover} />
                )}
                {cardData?.stripe_card_brand === 'eftpos_au' && (
                  <img alt="eftpos_au" className={css.image} src={eftpos_au} />
                )}
                {cardData?.stripe_card_brand === 'jcb' && (
                  <img alt="jcb" className={css.image} src={jcb} />
                )}
                {cardData?.stripe_card_brand === 'mastercard' && (
                  <img
                    alt="mastercard"
                    className={css.image}
                    src={mastercard}
                  />
                )}
                {cardData?.stripe_card_brand === 'unionpay' && (
                  <img alt="unionpay" className={css.image} src={unionpay} />
                )}
                {cardData?.stripe_card_brand === 'visa' && (
                  <img alt="visa" className={css.image} src={visa} />
                )}
                {cardData?.stripe_card_brand === 'unknown' && (
                  <img alt="unknown" className={css.image} src={unknown} />
                )}
                <div className={css.wrapPaymant}>
                  <div className={css.card_paymentTitle}>
                    Current payment method
                  </div>
                  <div className={css.card_infoText}>
                    {formattedString} ending in {cardData?.stripe_card_last4}
                  </div>
                  {cardData?.has_unpaid_invoice && (
                    <div className={css.card__error}>
                      Payment failed. Try again or update your card details.
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Button
              styled="payment"
              title={
                !cardData?.stripe_payment_method_id
                  ? 'Add Payment Method'
                  : 'Update Payment Method'
              }
              onClick={handlePayment}
            />
            {cardData?.has_unpaid_invoice && (
              <Button
                style={{ margin: '1rem 0 0 0' }}
                styled="payment"
                title={'Try Again'}
                onClick={() => {
                  setIsLoading(true);
                  apiv2
                    .MANUAL_PAYMENT()
                    .then(() =>
                      apiv2
                        .COMPANIES_BILLING_GET()
                        .then(res => dispatch(setCardData(res.data))),
                    );
                  apiv2
                    .GET_ME()
                    .then(res => {
                      dispatch(setMe(res.data));
                    })
                    .finally(() => setIsLoading(false));
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;
